import { render, staticRenderFns } from "./extract-network.vue?vue&type=template&id=5dd4f85a"
import script from "./extract-network.vue?vue&type=script&lang=js"
export * from "./extract-network.vue?vue&type=script&lang=js"
import style0 from "./extract-network.vue?vue&type=style&index=0&id=5dd4f85a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports